<template>
  <div class="ver-stock">
    <!-- Barra superior -->

    <!-- Resumen del inventario -->
    <div class="inventory-summary text-end p-3">
      <h1 class="inventory-count">{{ filteredStock.length }}</h1>
    </div>

    <!-- Contenido específico para Ver Stock -->
    <div class="content">
      <h2 class="text-center my-4">Ver Stock</h2>
      <p class="text-center mb-4">Aquí puedes ver todos los vestidos disponibles en el inventario.</p>

    <!-- Filtros mejorados -->
    <div class="filters-wrapper">
      <input
    type="text"
    v-model="filterQuery"
    class="form-control"
    placeholder="Buscar por código, color, modelo"
  />

  <select v-model="filterSize" class="form-control">
    <option value="">Talla</option>
    <option value="XS">XS</option>

    <option value="S">S</option>
    <option value="M">M</option>
    <option value="L">L</option>
    <option value="XL">XL</option>
    <option value="XXL">XXL</option>
  </select>

  <select v-model="filterNumTalla" class="form-control">
    <option value="">Num. Talla</option>
    <option value="2">2</option>
    <option value="4">4</option>
    <option value="6">6</option>
    <option value="8">8</option>
    <option value="10">10</option>
    <option value="12">12</option>
    <option value="14">14</option>
    <option value="16">16</option>
    <option value="18">18</option>
  </select>

 
  <select v-model="sortOrder" class="form-control">
    <option value="">Orden</option>
    <option value="asc">Ascendente</option>
    <option value="desc">Descendente</option>
  </select>
  <input
  type="date"
  v-model="filterDate"
  class="form-control"
  placeholder="Filtrar por fecha"
/>


  <div class="filters-actions">
    <button class="btn-clear-filters" @click="clearFilters">🧹 Limpiar filtros</button>
  </div>
</div>


      <!-- Catálogo de productos -->
      <div class="catalog-container">
        <div v-for="(item) in filteredStock" :key="item.id_vestido">

          <div
  class="card shadow-lg rounded-3 product-card animate__animated animate__fadeIn"
  @click="verHistorialRentas(item)"
>
<img
  :src="getImageUrl(item.foto_vestido)"
  alt="Imagen del vestido"
  class="card-img-top product-image"
/>



            <div class="card-body">
              <p class="code-tag"><strong>Código:</strong> {{ item.codigo_vestido }}</p>
              <h5 class="card-title">{{ item.modelo_vestido }}</h5>
              <p><strong>Marca:</strong> {{ item.marca }}</p>
              <p><strong>Color:</strong> {{ item.color }}</p>
              <p><strong>Talla:</strong> {{ item.talla }}</p>
              <p><strong>Num Talla:</strong> {{ item.num_talla }}</p>
              <p><strong>Costo de Renta:</strong> {{ formatCurrency(item.costo_renta) }}</p>
              <!-- Mostrar el costo de compra solo si el permiso es 4 -->
              <p v-if="parseInt(permisos) === 4"><strong>Costo de Compra:</strong> {{ formatCurrency(item.costo_compra) }}</p>
              <p :class="isVestidoDisponible(item.id_vestido) ? 'text-success' : 'text-danger'">
  <strong>Disponibilidad:</strong>
  {{ isVestidoDisponible(item.id_vestido) ? 'Disponible' : 'Ocupado' }}
</p>

            </div>
            <!-- Mostrar historial si este vestido está seleccionado -->
<!-- Mostrar historial si este vestido está seleccionado -->
<div v-if="vestidoSeleccionado === item.id_vestido" class="p-3 bg-light rounded mt-2 border">
  <h6 class="text-primary fw-bold mb-3">📅 Rentas programadas:</h6>

  <div
  v-for="(renta, index) in rentasVestidoSeleccionado"
  :key="renta.id_renta"
  @click="abrirModal(renta)"
  style="cursor: pointer"
>
    <div class="d-flex align-items-start mb-2">
      <div class="me-2">📍</div>
      <div><strong>Recoge:</strong> {{ formatDateDMY(renta.fecha_recoge) }}</div>
    </div>
    <div class="d-flex align-items-start mb-2">
      <div class="me-2">📦</div>
      <div><strong>Entrega:</strong> {{ formatDateDMY(renta.fecha_entrega) }}</div>
    </div>

    <!-- Línea divisoria -->
    <hr v-if="index !== rentasVestidoSeleccionado.length - 1" class="my-2" />
  </div>
</div>


            <div class="card-footer d-flex justify-content-between">
              <!-- Mostrar el botón de eliminar solo si el permiso es 4 -->
              <button v-if="parseInt(permisos) === 4" class="btn btn-danger" @click="deleteStock(item.id_vestido)">
                Eliminar
              </button>
              <button class="btn btn-primary" @click="editStock(item.id_vestido)">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de Detalles de Renta -->
<!-- Modal de Detalles de Renta -->
<div v-if="mostrarModal" class="modal-backdrop" @click.self="cerrarModal">
  <div class="modal-contenido px-4 py-3">

    <h5 class="text-primary mb-3">🧾 Detalles de la renta</h5>

    <div class="row mb-2">
  <div class="col-12">
    <strong>Cliente:</strong> {{ rentaSeleccionada.nombre_clienta }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <strong>Teléfono:</strong> {{ rentaSeleccionada.telefono }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-6">
    <strong>Modelo:</strong> {{ rentaSeleccionada.modelo_vestido }}
  </div>
  <div class="col-6">
    <strong>Color:</strong> {{ rentaSeleccionada.color }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-6">
    <strong>Talla:</strong> {{ rentaSeleccionada.talla }}
  </div>
  <div class="col-6">
    <strong>Número:</strong> {{ rentaSeleccionada.num_talla }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-6">
    <strong>Recoge:</strong> {{ formatDateDMY(rentaSeleccionada.fecha_recoge) }}
  </div>
  <div class="col-6">
    <strong>Entrega:</strong> {{ formatDateDMY(rentaSeleccionada.fecha_entrega) }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-6">
    <strong>Precio rentado:</strong> {{ formatCurrency(rentaSeleccionada.precio_rentado) }}
  </div>
  <div class="col-6">
    <strong>Anticipo:</strong> {{ formatCurrency(rentaSeleccionada.anticipo) }}
  </div>
</div>
<div class="row mb-2">
  <div class="col-6 text-success">
    <strong>Ajustes:</strong>
    <span>{{ rentaSeleccionada.ajustes === 'si' ? rentaSeleccionada.descripcion_ajustes : 'No hay ajustes' }}</span>
  </div>
  <div class="col-6 text-success" v-if="rentaSeleccionada.ajustes === 'si'">
    <strong>Costo ajustes:</strong> {{ formatCurrency(rentaSeleccionada.costo_ajustes) }}
  </div>
</div>


    <!-- Costo Ajustes -->
    <div class="mb-2" v-if="rentaSeleccionada.ajustes === 'si'">
      <strong class="text-success">Costo ajustes:</strong> {{ formatCurrency(rentaSeleccionada.costo_ajustes) }}
    </div>

    <!-- Botones -->
    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-danger" @click="cancelarRenta(rentaSeleccionada.id_renta)">Cancelar renta</button>
      <button class="btn btn-secondary" @click="cerrarModal">Cerrar</button>
    </div>

  </div>
</div>



  </div>


  
</template>


<script>
import axios from "axios";
import baseUrl from "../api"; // ✅ Correcto
import Swal from "sweetalert2";
import moment from "moment-timezone";

import { mapState } from "vuex";


export default {
  name: "VerStock",
  components: {
  },
  computed: {
    ...mapState(['permisos']),
    // Filtro computado
    filteredStock() {
      let filtered = this.stockList;
      console.log("Permisos actuales:", this.permisos); // Verifica el valor de permisos

      // Aplicar los filtros en los datos
      // Filtramos la lista de productos
      if (this.filterQuery) {
        const searchQuery = this.filterQuery.toLowerCase();
filtered = filtered.filter(item =>
  item.modelo_vestido.toLowerCase().includes(searchQuery) ||
  item.codigo_vestido.toLowerCase().includes(searchQuery) ||
  item.marca.toLowerCase().includes(searchQuery) ||
  item.color.toLowerCase().includes(searchQuery)
);

}

      

      if (this.filterSize) {
        filtered = filtered.filter(item => item.talla === this.filterSize);
      }

      if (this.filterNumTalla) {
        filtered = filtered.filter(item => item.num_talla == this.filterNumTalla);
      }

      if (this.filterColor) {
        filtered = filtered.filter(item => item.color === this.filterColor);
      }

      if (this.sortOrder) {
        filtered = filtered.sort((a, b) => {
          const dateA = new Date(a.fecha);
          const dateB = new Date(b.fecha);
          return this.sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
        });
      }

      return filtered; // Retorna los productos filtrados
    },
  },
  data() {
    const zona = moment.tz.guess();

    return {
      stockList: [], // Lista de productos en stock
      filterQuery: "", // Filtro por modelo
      filterSize: "", // Filtro por talla
      filterNumTalla: "", // Filtro por número de talla
      filterColor: "", // Filtro por color
      sortOrder: "", // Filtro por orden

filterDate: moment().tz(zona).format("YYYY-MM-DD"),
      rentasFuturas: [], // 🆕 Para guardar todas las rentas que vienen
      vestidoSeleccionado: null,
rentasVestidoSeleccionado: [],
mostrarModal: false,
rentaSeleccionada: null,


    };
  },

  created() {
    
    this.fetchStock();
  this.fetchRentas(); // 🆕
  const permisosLocal = localStorage.getItem('permisos');
  if (permisosLocal) {
    this.$store.commit('setPermisos', permisosLocal);
  } else {
    this.fetchPermisos();
    }
  },

  
  methods: {
    getImageUrl(foto) {
    if (!foto) return ''; // Protección
    return `${baseUrl}/${foto}`;
  },
    abrirModal(renta) {
  this.rentaSeleccionada = renta;
  this.mostrarModal = true;
},
cerrarModal() {
  this.mostrarModal = false;
  this.rentaSeleccionada = null;
},


    formatDateDMY(fecha) {
  const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const d = new Date(fecha);
  const dia = d.getDate();
  const mes = meses[d.getMonth()];
  const año = d.getFullYear();
  return `${dia} ${mes} ${año}`;
}

,
    async fetchRentas() {
  try {
    const response = await axios.get(`${baseUrl}/api/disponibilidad-rentas`);
    const hoy = new Date().toISOString().split("T")[0];

    this.rentasFuturas = response.data.filter(r => {
      const fechaRecoge = r.fecha_recoge?.split("T")[0];
      const fechaEntrega = r.fecha_entrega?.split("T")[0];
      return (fechaRecoge >= hoy || fechaEntrega >= hoy);
    });
  } catch (error) {
    console.error("Error al obtener rentas:", error);
  }
}
,isVestidoDisponible(id_vestido) {
  const fecha = this.filterDate;
  if (!fecha) return false;

  return !this.rentasFuturas.some(r => {
    const fechaRecoge = r.fecha_recoge?.split("T")[0];
    const fechaEntrega = r.fecha_entrega?.split("T")[0];

    return (
      r.id_vestido === id_vestido &&
      fecha >= fechaRecoge &&
      fecha <= fechaEntrega &&
      r.entregado !== 'si' &&
      r.cancelado !== 'si'
    );
  });




  },

  async verHistorialRentas(vestido) {
  this.vestidoSeleccionado = vestido.id_vestido;

  try {
    const response = await axios.get(`${baseUrl}/api/historial-vestido/${vestido.id_vestido}`);
    this.rentasVestidoSeleccionado = response.data;
  } catch (error) {
    console.error("Error al cargar historial:", error);
  }
}


,
    editStock() {
    // Mostrar alerta de que la funcionalidad está pendiente
    Swal.fire({
        icon: "error",
        title: "Error",
        text: response.data.message || "Esta funcionalidad no esta disponible por el momento",
      });    
    // Aquí puedes agregar el código para manejar el editar cuando esté disponible
    // Por ahora no hace nada, solo muestra la alerta
  },


//cancelarrenta

  async cancelarRenta(id_renta) {
  const confirm = await Swal.fire({
    title: "¿Cancelar esta renta?",
    text: "Esta acción no se puede deshacer.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#aaa",
    confirmButtonText: "Sí, cancelar",
    cancelButtonText: "No"
  });

  if (confirm.isConfirmed) {
    try {
      const response = await axios.delete(`${baseUrl}/api/cancelar-rentas/${id_renta}`);
      if (response.status === 200) {
        Swal.fire("Cancelada", "La renta ha sido cancelada correctamente.", "success");
        this.mostrarModal = false;
        this.fetchRentas(); // recarga la disponibilidad
        this.verHistorialRentas({ id_vestido: this.vestidoSeleccionado }); // actualiza el historial
      }
    } catch (error) {
      console.error("Error al cancelar renta:", error);
      Swal.fire("Error", "No se pudo cancelar la renta.", "error");
    }
  }
}
,async deleteStock(id) {
  const { value: password, isConfirmed } = await Swal.fire({
    title: "¿Estás segura?",
    text: "Para eliminar este vestido, ingresa la contraseña:",
    input: "password",
    inputLabel: "Contraseña",
    inputPlaceholder: "Escribe la contraseña para confirmar",
    inputAttributes: {
      maxlength: 20,
      autocapitalize: "off",
      autocorrect: "off"
    },
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar"
  });

  // Validación real después del cierre del modal
  if (!isConfirmed) return;

  if (password !== "12karen") {
    Swal.fire({
      icon: "error",
      title: "Contraseña incorrecta",
      text: "No se realizó ninguna acción.",
    });
    return;
  }

  // Si la contraseña es correcta
  try {
    const response = await axios.delete(`${baseUrl}/api/stock/${id}`);
    if (response.status === 200) {
      this.stockList = this.stockList.filter(item => item.id_vestido !== id);
      Swal.fire({
        icon: "success",
        title: "Eliminado",
        text: "El vestido fue eliminado correctamente.",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.data.message || "No se pudo eliminar el vestido.",
      });
    }
  } catch (error) {
    console.error("Error al eliminar:", error);
    Swal.fire({
      icon: "error",
      title: "Error del servidor",
      text: "Ocurrió un error al eliminar el vestido.",
    });
  }
}


,




  
    async fetchStock() {
      try {
        const response = await axios.get(`${baseUrl}/api/stock`);
        this.stockList = response.data;
// Si tienes un array reactivo llamado "vestidos"
console.log(this.stockList[0]); // Muestra el primer objeto del array

      } catch (error) {
        console.error("Error al obtener el stock:", error);
        Swal.fire({
          icon: "error",
          title: "Error al cargar el stock",
          text: "Ocurrió un error al cargar la lista de productos.",
        });
      }
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    clearFilters() {
      this.filterQuery = "";
      this.filterSize = "";
      this.filterNumTalla = "";
      this.filterColor = "";
      this.sortOrder = "";
    },
  },









  
  watch: {
    permisos(newPermisos) {
      // Cuando los permisos cambian, podemos forzar una actualización
      console.log("Permisos cambiados:", newPermisos);
      this.$forceUpdate(); // Forzamos el renderizado del componente
    },
    filterQuery(newQuery) {
      // Cuando cambia el filtro de búsqueda, se puede ajustar cualquier lógica adicional
      console.log("Filtro de búsqueda cambiado:", newQuery);
    },
    filterSize(newSize) {
      console.log("Filtro de talla cambiado:", newSize);
    },
    filterNumTalla(newNumTalla) {
      console.log("Filtro de número de talla cambiado:", newNumTalla);
    },
    filterColor(newColor) {
      console.log("Filtro de color cambiado:", newColor);
    },
  },
};
</script>

 
  
  <style scoped>
.catalog-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  padding: 0 10px;
}


/* Tarjetas más compactas */
.product-card {
  font-size: 12px;
  padding: 8px;
  border-radius: 10px;
  background-color: white;
  transition: transform 0.2s ease-in-out;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 10px;
  flex: 1;
}

.filters-actions {
  display: flex;
  align-items: center;
}

.btn-clear-filters {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  height: 38px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-clear-filters:hover {
  background-color: #e0e0e0;
  border-color: #aaa;
}

.filter-grid select,
.filter-grid input {
  height: 38px;
  font-size: 14px;
}



.product-card:hover {
  transform: scale(1.02);
}


/* Imagen pequeña y proporcionada */
.product-image {
  height: 120px;
  object-fit: contain;
  background-color: #f8f8f8;
  padding: 5px;
  border-radius: 8px 8px 0 0;
}

/* Texto más compacto */
.card-body p {
  font-size: 11px;
  margin: 2px 0;
}

.card-title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 4px;
}

/* Footer más delgado */
.card-footer {
  text-align: center;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}

/* Botones más delgados */
button {
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-size: 11px;
  padding: 4px 6px;
  margin: 0;
}

button:hover {
  background-color: #0056b3;
  transform: scale(1.03);
}

/* Etiqueta compacta */
.code-tag {
  background-color: #b0889c40;
  color: #000;
  padding: 3px 6px;
  font-size: 10px;
  border-radius: 8px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 6px;
  text-transform: uppercase;
}.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-contenido {
  background: #fff;
  padding: 30px;
  border-radius: 15px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  animation: fadeIn 0.3s ease-in-out;
  position: relative;
  z-index: 1051;
}

/* Confirmación modal más alto */
.modal-confirmacion {
  z-index: 1060 !important;
}


/* Márgenes generales */
.ver-stock {
  margin-top: 0px;
}

/* Resumen compacto */
.inventory-summary {
  padding: 10px 20px;
  color: #333;
}

.inventory-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444;
  margin: 0;
  letter-spacing: 1px;
}
.filters-wrapper {
  background: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}


.filters-wrapper input,
.filters-wrapper select {
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.filters-wrapper button {
  padding: 6px 10px;
  font-size: 13px;
  background-color: #f4f4f4;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filters-wrapper button:hover {
  background-color: #ddd;
}

.inventory-count {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0;
  color: #aa8a9d;
  font-family: 'Poppins', sans-serif;
}


  </style>
  